import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import {toast} from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import { usePaymentCheckoutMutation } from '../../api/paymentApi';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import './style.scss';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { cartStateUpdate } from '../../store/reducers/cartSlice';
import { TbBorderRadius } from 'react-icons/tb';
import { payHub } from '../../api/Base/payHubModel';
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import { shoppingCartApi } from '../../api/shoppingCartApi';
import { radio } from '@material-tailwind/react';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  };

const CheckWrap = (props) => {
    const [open, setOpen] = React.useState(false);
    const [hubConnection,setHubConnection] = useState();
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [CreatePayment] = usePaymentCheckoutMutation();
    const authenticationState = useSelector((state) => state.authStore)
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
    const [status, setStatus] = useState('');
    const [isActive3dSecure,setIsActive3dSecure] = useState(false);
    const nameIdentifier = useSelector((state) => state.authStore.nameIdentifier);
    const push = useNavigate()
    const [isRadio, setIsRadio] = useState(false);
    const Dispatch = useDispatch();
    const [html, setHtml] = useState(null);
    const [value, setValue] = useState({
        email: 'user@gmail.com',
        password: '123456',
        card_holder: 'Jhon Doe',
        card_number: '589622144',
        cvv: '856226',
        expire_month: '',
        expire_year:'',
        remember: false,
    });
    const createHubConnection = async () => {
        const hubConnection = new HubConnectionBuilder()
            .withUrl(payHub, {
                accessTokenFactory: () => nameIdentifier,
            })
            .configureLogging(LogLevel.Information)
            .build();
    
        try {
            await hubConnection.start();
        } catch (error) {
            console.error("Error while starting connection: ", error);
        }
    
        setHubConnection(hubConnection);
    };


    useEffect(()=>{
        if (hubConnection) {
                hubConnection.on("MessageForSocket",(res) => {
                  if (res.item1 == "success") {
                    push('/order_received');
                    handleClose();
                    Dispatch(cartStateUpdate(res.item2))
                  }
                  else{
                    toast.warning(res.item3)
                    handleClose();
                  }
                })
        }
    },[hubConnection])
    const changeHandler = (e) => {
        setValue({...value, [e.target.name]: e.target.value});
        validator.showMessages();
    };


    useEffect(()=>{
        createHubConnection();

    },[nameIdentifier])


    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = async (e) => {
        e.preventDefault();

        if (!value.card_holder || !value.card_number || !value.cvv || !value.expire_month || !value.expire_year) {
            toast.warning("Please fill out all required fields.")
            return; 
        }
        var formData = new FormData();

        if (validator.allValid()) {
            // setValue({
            //     email: '',
            //     password: '',
            //     card_holder: '',
            //     card_number: '',
            //     cvv: '',
            //     expire_date: '',
            //     remember: false
            // });
       

            formData.append("CardHolderName",value.card_holder);
            formData.append("CardNumber",value.card_number);
            formData.append("ExpireMonth",value.expire_month);
            formData.append("ExpireYear",value.expire_year);
            formData.append("CardHolderName",value.card_holder);
            formData.append("CouponCode",props.values.cupon_key);
            formData.append("cvc",value.cvv);
            formData.append("IdentityNumber",props.values.identityNumber);
            formData.append("RegistrationAddress",props.values.address);
            formData.append("City",props.values.dristrict);
            formData.append("Country",props.values.country);
            formData.append("ZipCode",props.values.post_code);
            formData.append("UserId",authenticationState.nameIdentifier);

            const sendData = {
                paymentModel:formData,
                isActive3dSecure:isRadio
            }

    await CreatePayment(sendData).then((response) => {
        validator.hideMessages();
        const userRegex = /^user+.*/gm;
        const email = value.email;
        if (email.match(userRegex) && response.data.isSuccess ) {
            if (isRadio) {
                const blob = new Blob([response.data.result[0].item1.content], { type: "text/html" });
                const objUrl = URL.createObjectURL(blob);
                setHtml(objUrl);
                handleOpen();    
            }
            else if (!isRadio) {
                if (response.data.isSuccess && response.data.result[1].item2.status == "success") {
                    toast.success(response.data.messages[0]); 


                    Dispatch(cartStateUpdate(response.data.result[0]))

                    push('/order_received');        
                }
            }

            
        }  else if(!response.data.isSuccess) {
            toast.info(response.data.messages[0] + ".Please check your information again");
            // alert('user not existed! credential is : user@*****.com | vendor@*****.com | admin@*****.com');
        }
     })
          
        } else {
            validator.showMessages();
            toast.error('Empty field is not allowed!');
        }
    };
    return (
        <>
        <div className="modern-payment-form">
            {/* 3D Secure Seçeneği */}
            <div className="secure-options">
                <div className="secure-option-header">
                    <i className="fi flaticon-shield"></i>
                    <h4>Güvenlik Seçenekleri</h4>
                </div>
                <RadioGroup 
                    className="modern-radio-group" 
                    aria-label="Payment Method"
                    name="payment_method"
                    onChange={(e) => setIsRadio(!isRadio)}
                >
                    <div className="radio-option-card">
                        <FormControlLabel 
                            value="secure" 
                            control={<Radio checked={isRadio === true} color="primary"/>}
                            label={
                                <div className="radio-label">
                                    <i className="fi flaticon-verified"></i>
                                    <span>3D Secure ile Ödeme (Önerilen)</span>
                                </div>
                            }
                        />
                    </div>
                    <div className="radio-option-card">
                        <FormControlLabel 
                            value="nosecure" 
                            control={<Radio checked={isRadio === false} color="primary"/>}
                            label={
                                <div className="radio-label">
                                    <i className="fi flaticon-credit-card"></i>
                                    <span>Standart Ödeme</span>
                                </div>
                            }
                        />
                    </div>
                </RadioGroup>
            </div>

            {/* Kart Bilgileri Formu */}
            <form onSubmit={submitForm} className="card-details-form">
                <div className="form-section-header">
                    <i className="fi flaticon-credit-card"></i>
                    <h4>Kart Bilgileri</h4>
                </div>
                
                <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <div className="modern-input-wrapper">
                            <TextField
                                fullWidth
                                label="Kart Sahibinin Adı"
                                name="card_holder"
                                value={value.card_holder}
                                onChange={(e) => changeHandler(e)}
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                className="modern-text-field"
                                required
                            />
                        </div>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <div className="modern-input-wrapper">
                            <TextField
                                fullWidth
                                label="Kart Numarası"
                                name="card_number"
                                value={value.card_number}
                                onChange={(e) => changeHandler(e)}
                                type="number"
                                InputLabelProps={{ shrink: true }}
                                className="modern-text-field"
                                required
                            />
                        </div>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <div className="modern-input-wrapper">
                            <TextField
                                fullWidth
                                label="CVV / CVC"
                                name="cvv"
                                value={value.cvv}
                                onChange={(e) => changeHandler(e)}
                                type="text"
                                InputLabelProps={{ shrink: true }}
                                className="modern-text-field"
                                required
                            />
                        </div>
                    </Grid>
                    <Grid item sm={3} xs={6}>
                        <div className="modern-input-wrapper">
                            <TextField
                                fullWidth
                                label="Ay (MM)"
                                name="expire_month"
                                value={value.expire_month}
                                onChange={(e) => changeHandler(e)}
                                type="number"
                                InputLabelProps={{ shrink: true }}
                                className="modern-text-field"
                                placeholder="12"
                                required
                            />
                        </div>
                    </Grid>
                    <Grid item sm={3} xs={6}>
                        <div className="modern-input-wrapper">
                            <TextField
                                fullWidth
                                label="Yıl (YY)"
                                name="expire_year"
                                value={value.expire_year}
                                onChange={(e) => changeHandler(e)}
                                type="number"
                                InputLabelProps={{ shrink: true }}
                                className="modern-text-field"
                                placeholder="26"
                                required
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Button 
                            fullWidth 
                            className="modern-submit-btn" 
                            type="submit"
                        >
                            <i className="fi flaticon-checked"></i>
                            <span>Ödemeyi Tamamla</span>
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>


<div>
<Modal
  keepMounted
  open={open}
  onClose={handleClose}
  aria-labelledby="keep-mounted-modal-title"
  aria-describedby="keep-mounted-modal-description"
>
  <Box sx={style}>
    
    {html && <iframe src={html} width="500" height="500" title="Payment"></iframe>}
  </Box>
</Modal>
</div>
</>
    )
};

export default CheckWrap;